import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  GetServiceSetData,
  GetSubscriptionSetData,
} from "../../../../../../Api/ServiceDatas";
import { pwAutoChangeMain } from "../../../../../../ApiTS/ApiPwAutoChangeTS";
import ConfirmBtn from "../../../../../Button/ConfirmBtn";
import Loader from "../../../../../DefaultStyles/Loader";
import AlertModal from "../../../../../Modal/AlertModal";

interface PwAutoChangeBtnProps {
  subsId: number;
  id: string;
  pw: string;
  confirmEvent: (pw: string) => void;
}

/** 랜덤 비밀번호 생성 */
export const randomPw = (subsId: number, prefix?: string) => {
  const engChars = "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
  const numChars = "0123456789";

  const engStringLength = 4; // 영문자 중 4개
  const numStringLength = 1; // 숫자 중 1개

  let randomstring = "";

  // 영문자 랜덤 추출
  for (let i = 0; i < engStringLength; i++) {
    const rnum = Math.floor(Math.random() * engChars.length);

    randomstring += engChars.substring(rnum, rnum + 1);
  }

  // 숫자 랜덤 추출
  for (let i = 0; i < numStringLength; i++) {
    const rnum = Math.floor(Math.random() * numChars.length);

    randomstring += numChars.substring(rnum, rnum + 1);
  }

  const randomStringArr = [...randomstring];

  // 문자열 섞기
  for (let i = randomStringArr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [randomStringArr[i], randomStringArr[j]] = [
      randomStringArr[j],
      randomStringArr[i],
    ];
  }

  randomstring = randomStringArr?.join("");

  return `${
    prefix ?? `help${subsId === 4000 || subsId === 4001 ? "@" : "-"}`
  }${randomstring}`;
};

export default function PwAutoChangeBtn({
  subsId,
  id,
  pw,
  confirmEvent,
}: PwAutoChangeBtnProps) {
  const [askChangeAlert, setAskChangeAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const subsData = GetSubscriptionSetData(subsId ?? 0)[0];
  const serviceName = GetServiceSetData(subsData?.SVC_ID)[0]?.SVC_NMKR_TEMP;

  const pwAutoChange = async () => {
    setIsLoading(true);

    const newPw = randomPw(subsId);

    console.log(newPw);

    const response = await pwAutoChangeMain(subsId, id, pw, newPw);

    if (response) {
      setIsLoading(false);

      if (response?.data && response?.data?.hasChanged) {
        confirmEvent(
          response?.data?.pw_new !== "" ? response?.data?.pw_new : newPw
        );
        toast.success(`${serviceName} 비밀번호가 성공적으로 변경되었습니다.`);
      } else {
        toast.error(`${serviceName} 비밀번호를 바꾸는 데에 실패하였습니다.`);
      }
    }
  };

  return (
    <>
      <ConfirmBtn
        btnText="재설정"
        btnColor="mint"
        btnClickEvent={() => setAskChangeAlert(true)}
        btnHeight={38}
      />

      {isLoading && <Loader />}

      {askChangeAlert && (
        <AlertModal
          title={`${serviceName}의 비밀번호가 자동 변경됩니다.
      계속 하시겠습니까?`}
          cancelEvent={() => setAskChangeAlert(false)}
          confirmEvent={() => pwAutoChange()}
        />
      )}
    </>
  );
}
